export const TourGuideList = {
  //Danh sách Hướng dẫn sử dụng TaskGo2: Những Điểm nổi bật của TaskGo2 so với TaskGo1
  TourGuideUpdate: [
    {
      target: '#dashboard',
      title: 'Tổng quan',
      description:
        'Bạn có thể theo dõi nhanh tình hình thực hiện công việc tại các đơn vị trực thuộc mình quản lý, tại đơn vị mình hay công việc của bản thân để đôn đốc, chỉ đạo kịp thời.',
      padding: 1,
      position: 'right',
      linkHelpID: 'General',
      routeCloseName: 'dashboard',
    },
    {
      target: '.dashboard-header-tabs',
      title: 'Tổng quan',
      description:
        '- Tôi quản lý: Theo dõi tình hình thực hiện công việc của cả đơn vị trực thuộc cấp dưới và đơn vị mình.<br>- Đơn vị tôi: Theo dõi tình hình thực hiện công việc trong chính đơn vị mình. <br>- Của tôi: Theo dõi tình hình thực hiện công việc của cá nhân mình <br>',
      padding: 1,
      position: 'bottom-center',
      linkHelpID: 'General',
      routeCloseName: 'dashboard',
    },
    {
      target: '.edit-btn-circle',
      title: 'Tùy chỉnh biểu đồ',
      description:
        'Tùy theo nhu cầu quản lý công việc thực tế tại đơn vị, bạn có thể tùy chỉnh hiển thị các biểu đồ hiển thị bằng cách nhấn vào biểu tượng cây bút.',
      padding: 1,
      position: 'top-left',
      circle: 'customChart',
      linkHelpID: 'CustomChart',
      routeCloseName: 'dashboard',
    },

    {
      target: '#task',
      title: 'Danh sách công việc',
      description:
        'Bạn có thể truy cập nhanh danh sách công việc đã được sắp xếp vào từng mục tương ứng.',
      padding: 1,
      position: 'right',
      linkHelpID: 'TaskList',
      routeName: 'needtodo',
      routeCloseName: 'dashboard',
    },
    {
      target: '#setting',
      title: 'Thiết lập chung',
      description:
        'Giúp bạn thiết lập những thông tin ban đầu để bắt đầu sử dụng phần mềm.',
      padding: 1,
      position: 'right',
      linkHelpID: 'GeneralSetting',
      routeName: 'general-setting',
      routeCloseName: 'dashboard',
    },
    {
      target: '#quick-icon-list',
      title: 'Liên hệ với tư vấn viên',
      description:
        'Chọn vào biểu tượng tin nhắn để liên hệ với chúng tôi nếu cần hỗ trợ.',
      padding: 1,
      position: 'top-left',
    },
    {
      target: '.dashboard-header-help ',
      title: 'Bắt đầu sử dụng',
      description: 'Các bước thiết lập cần thiết cho đơn vị trước khi sử dụng',
      padding: 1,
      routeName: 'dashboard',
      routeCloseName: 'dashboard',
    },
  ],
};
